import axios from 'axios';

export const exportAllSkus = (projectId, params) => axios.get(`/projects/${projectId}/skus/export`, { params });
export const exportNonSkus = (projectId, params) => axios.get(`/projects/${projectId}/non_sku_classes/export`, { params });
export const fetchNonSkuClassesWithParams = (projectId, params) => axios.get(`/projects/${projectId}/non_sku_classes`, { params });
